module.exports = __webpack_public_path__ + "img/setup34-logo.beb8c55e.svg";